import React, {FC} from "react"
import {Label} from "@irati/ui/src/Typography"
import {SelectorComponent, BackgroundColorIcon} from "./styled"
import Icon, {IconTypes} from "../Icon"
import Flex from "../Flex"
import BaseSvgIcon from "../Icon/customIcons/Base"

export interface SelectorProps {
  id?: string,
  name: string,
  uuid?: string,
  onClick: (id: string, name: string) => void,
  selected?: boolean,
  className?: string,
  icon?: IconTypes,
  count?: number,
  iconBgColor?: string,
  svgData?: string
}

const Selector: FC<SelectorProps> = ({name, uuid = "", onClick, selected, className, count, icon, iconBgColor, svgData, id}) => {
  return (
    <SelectorComponent id={id} selected={selected} onClick={() => onClick(uuid, name)} className={className}>
      <Flex direction="column">
        {icon && (
          <BackgroundColorIcon selected={selected} iconBgColor={iconBgColor}>
            <Icon icon={icon} size={30} />
          </BackgroundColorIcon>
        )}
        {svgData && (
          <BackgroundColorIcon selected={selected} iconBgColor={iconBgColor}>
            <BaseSvgIcon viewBox="0 0 30 30" width={30} height={30}>
              <path d={svgData} />
            </BaseSvgIcon>
          </BackgroundColorIcon>
        )}
        {name}
      </Flex>
      {count && (
        <Flex position="absolute" top="8px" right="8px">
          <Label>{`(${count})`}</Label>
        </Flex>
      )}
    </SelectorComponent>
  )
}

export default Selector
